export const SET_USER = 'SET_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const SET_FIRST_NAME = 'SET_FIRST_NAME'
export const SET_LAST_NAME = 'SET_LAST_NAME'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_INFO = 'SET_INFO'
export const HANDLE_LOGOUT = 'HANDLE_LOGOUT'
export const SIDEBAR_STATUS = 'SIDEBAR_STATUS'
export const TOGGLE_SCALED_DASHBOARD = 'TOGGLE_SCALED_DASHBOARD'
